import { useEffect } from 'react'
import { audioService } from '@/services/audio'

const SOUND_FILES = [
  'lesson-start',
  'lesson-end',
  'activity-start',
  'timer-warning',
  'timer-urgent',
  'time-up',
  'player-joined',
  'response-received',
  'all-responded',
] as const

export function useAudio() {
  useEffect(() => {
    for (const name of SOUND_FILES) {
      audioService.preload(name, `/sounds/${name}.mp3`)
    }
  }, [])

  return {
    play: (name: string) => audioService.play(name),
    setEnabled: (v: boolean) => audioService.setEnabled(v),
    setVolume: (v: number) => audioService.setVolume(v),
  }
}
